import ContactDetailController from 'controllers/settings/contacts/contactDetailController';

export default class UserContactDetailController extends ContactDetailController {
    _showDeletionModal() {}

    enableInputFields() {}
}
